import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import type { Schema } from "@bw/shared/types/generated";

import { queryKeys } from "../../../common/query/queryClient";

/**
 * Auth-gated, server-scoped certificate list for the current player. This hook
 * never accepts or exposes another player's identity; the API derives it from
 * the session and returns only archive-bound certificates the player owns.
 */
export function useMyTournamentArchiveCertificates(
  tournamentId: string,
  enabled: boolean,
) {
  const { user } = useAuth();
  return useQuery<Schema["TournamentOwnArchiveCertificateResponse"][]>({
    queryKey: queryKeys.tournaments.archiveCertificatesMine(tournamentId),
    queryFn: () => tournamentApi.listMyArchiveCertificates(tournamentId),
    enabled: enabled && Boolean(user && tournamentId),
  });
}
